import { useQuery } from "@tanstack/react-query";
import { fetchSession } from "./api";

/**
 * "Who is signed in", shared by the sign-in page and the admin dashboard so
 * the query key and the renewal behaviour cannot drift between the two
 * places that ask the same question.
 */
export function useSession() {
  return useQuery({
    queryKey: ["session"],
    queryFn: fetchSession,
  });
}
